import { ProductCategoryType } from 'farmdok-rest-api';

export type AdditionalDetailsPropertyKey =
  | 'thousandGrainWeight'
  | 'moistureContent'
  | 'proteinContent'
  | 'hectoliterWeight'
  | 'sugarContent'
  | 'starchContent'
  | 'temperature'
  | 'windSpeed'
  | 'relativeHumidity';

export type AdditionalDetailsCategory = 'product' | 'weather';

export type AdditionalDetailsProperty = {
  key: AdditionalDetailsPropertyKey;
  name: string;
  unit: string;
  category: AdditionalDetailsCategory;
  visibleForProductCategoryTypes?: ProductCategoryType[];
};

const CROP_OR_HARVEST_PRODUCT_CATEGORY_TYPES: ProductCategoryType[] = [
  ProductCategoryType.Crop,
  ProductCategoryType.Harvest,
];

export const additionalDetailsProperties: AdditionalDetailsProperty[] = [
  {
    key: 'thousandGrainWeight',
    name: 'Tausendkorngewicht',
    unit: 'g',
    category: 'product',
    visibleForProductCategoryTypes: [ProductCategoryType.Seed],
  },
  {
    key: 'moistureContent',
    name: 'Feuchtigkeit',
    unit: '%',
    category: 'product',
    visibleForProductCategoryTypes: CROP_OR_HARVEST_PRODUCT_CATEGORY_TYPES,
  },
  {
    key: 'proteinContent',
    name: 'Proteingehalt',
    unit: '%',
    category: 'product',
    visibleForProductCategoryTypes: CROP_OR_HARVEST_PRODUCT_CATEGORY_TYPES,
  },
  {
    key: 'hectoliterWeight',
    name: 'Hektolitergewicht',
    unit: 'kg/hl',
    category: 'product',
    visibleForProductCategoryTypes: CROP_OR_HARVEST_PRODUCT_CATEGORY_TYPES,
  },
  {
    key: 'sugarContent',
    name: 'Zuckergehalt',
    unit: '%',
    category: 'product',
    visibleForProductCategoryTypes: CROP_OR_HARVEST_PRODUCT_CATEGORY_TYPES,
  },
  {
    key: 'starchContent',
    name: 'Stärkegehalt',
    unit: '%',
    category: 'product',
    visibleForProductCategoryTypes: CROP_OR_HARVEST_PRODUCT_CATEGORY_TYPES,
  },
  {
    key: 'temperature',
    name: 'Temperatur',
    unit: '°C',
    category: 'weather',
  },
  {
    key: 'windSpeed',
    name: 'Windgeschwindigkeit',
    unit: 'km/h',
    category: 'weather',
  },
  {
    key: 'relativeHumidity',
    name: 'Relative Feuchtigkeit',
    unit: '%',
    category: 'weather',
  },
];

export const additionalDetailsCategoryHeadlineKeys: Record<AdditionalDetailsCategory, string> = {
  product: 'Produkt',
  weather: 'Wetter',
};

export function isAdditionalDetailsPropertyVisible(
  property: AdditionalDetailsProperty,
  selectedProductCategoryType: ProductCategoryType | null,
): boolean {
  if (property.category === 'weather') {
    return true;
  }

  if (!property.visibleForProductCategoryTypes || property.visibleForProductCategoryTypes.length < 1) {
    return true;
  }

  if (!selectedProductCategoryType) {
    return false;
  }

  return property.visibleForProductCategoryTypes.includes(selectedProductCategoryType);
}
